import getQuickSearchInitValues from './getQuickSearchInitValues'
import getQuickSearchSubmitValues from './getQuickSearchSubmitValues'

const transConfigValues = ({
    form,
    fieldsGroup,
    sortFields: inputSortFields,
    sortValues: inputSortValues,
    selectName,
    values
}) => {
    const { queryFields: newQueryFields, sortValues: newSortValues } = getQuickSearchInitValues({
        form,
        fieldsGroup,
        values,
        sortFields: inputSortFields,
        sortValues: inputSortValues
    })

    return getQuickSearchSubmitValues({
        quickSearchName: selectName,
        queryFields: newQueryFields,
        sortFields: inputSortFields,
        sortValues: newSortValues
    })
}

export default async ({ form, fieldsGroup, sortFields, sortValues, config }) => {
    const configList = config.filters

    const localData = form.getLocalData() || {}

    await Promise.all(
        Object.values(localData)
            .filter(v => typeof v.init === 'function')
            .map(v => v.init())
    )

    const resList = configList.map(v =>
        transConfigValues({
            form,
            fieldsGroup,
            sortFields,
            sortValues,
            selectName: v.selectName,
            values: v.fields
        })
    )

    console.info('upgradeQuickSearchConfigValues:', resList)

    return resList
}
